var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";

import { TableTitle } from "./TableTitle";

const extractorColumnHelper = createColumnHelper();

const TableHeaderContainer = ({ children }) => /*#__PURE__*/
_jsx("span", { className: "text-gray-500 font-semibold text-xs" }, void 0, children);


const TemplateFromHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Template")
);

const TemplateToHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Target Template")
);

const DocumentsHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Documents")
);

const GeneratedEntitiesHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Generated Entities")
);

const ActionHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Action")
);


const NumericCell = ({
  cell
}) => /*#__PURE__*/
_jsx("span", { className: "text-sm font-normal text-gray-500" }, void 0, cell.getValue());


const TemplatesCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0, /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, cell.getValue())
)
);


const TemplateFromCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((value) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, value, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, value)
)
)
);


const LinkButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `${cell.getValue()}/entities` }, void 0, /*#__PURE__*/
_jsx(Button, { className: "leading-4", styling: "outline" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "View")
)
);


const tableColumns = [
extractorColumnHelper.accessor('originTemplateNames', {
  header: TemplateFromHeader,
  enableSorting: true,
  cell: TemplateFromCell
}),
extractorColumnHelper.accessor('targetTemplateName', {
  header: TemplateToHeader,
  enableSorting: true,
  cell: TemplatesCell
}),
extractorColumnHelper.accessor('documents', {
  header: DocumentsHeader,
  enableSorting: true,
  cell: NumericCell
}),
extractorColumnHelper.accessor('generatedEntities', {
  header: GeneratedEntitiesHeader,
  enableSorting: true,
  cell: NumericCell
}),
extractorColumnHelper.accessor('_id', {
  header: ActionHeader,
  enableSorting: true,
  cell: LinkButton
})];


export { tableColumns, TableTitle };